import { useEffect, useState } from 'react';
import { Typography } from '../typography';
import { Button } from '../button';
import { enqueueSnackbar } from '../snackbar';
import { ModalBase, ModalWrapper, ModalFooterButtons } from './ModalComponents';
import { useRepairConfirmMutation } from '../../hooks';
import { MESSAGES } from '../../const';
import { i18n } from '../../i18n';

export const repairClientConfirmModal: any = {};

export const RepairClientConfirmModal = () => {
  const { mutate } = useRepairConfirmMutation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    repairClientConfirmModal.open = () => {
      repairClientConfirmModal.action = repairClientConfirmModal.isConfirm
        ? i18n.t('dropdown.approve')
        : i18n.t('dropdown.reject');
      repairClientConfirmModal.name = `${repairClientConfirmModal.action} ${i18n.t(
        'pages.modal.repairTitle',
      )}: ${repairClientConfirmModal.number}`;

      setOpen(true);
    };
  }, []);

  const handleOnClose = () => {
    Object.keys(repairClientConfirmModal).forEach((key) => {
      if (key !== 'open') delete repairClientConfirmModal[key];
    });
    setOpen(!open);
  };

  const handleSubmitClick = async () => {
    mutate(
      { id: repairClientConfirmModal.id, isConfirm: repairClientConfirmModal.isConfirm },
      {
        onSuccess: () => {
          setOpen(false);
          repairClientConfirmModal.submitClick();
        },
        onError: () => {
          enqueueSnackbar(MESSAGES.REPAIR.ERROR.NOT_CLIENT_CONFIRMED, 'error');
        },
      },
    );
  };

  return (
    <ModalBase id={'repair-client-confirm-modal'} open={open} onClose={handleOnClose}>
      <ModalWrapper>
        <Typography variant={'textL'} weight={'bold'}>
          {repairClientConfirmModal.name}
        </Typography>
        <ModalFooterButtons>
          <Button size={'medium'} data-color={'white'} onClick={handleOnClose}>
            {i18n.t('button.cancel')}
          </Button>
          <Button size={'medium'} data-color={'primary'} onClick={handleSubmitClick}>
            {i18n.t('button.submit')}
          </Button>
        </ModalFooterButtons>
      </ModalWrapper>
    </ModalBase>
  );
};
